import storageService from '@/services/storage.service';
import { loginService } from '@/services/login.service';
import { HttpRequestConfig, HttpRequestDataType, HttpResponse } from '@/utils/http-utils';
import siteConfigService from '@/services/site.config.service';
import httpService from '@/services/http.service';
import Logger from '@/utils/logger.utils';
import SSOToken from '@/entities/ssokoken';
import logoutHandler from '@/events/handlers/logout.handler';
import { ssoTokenValidationService, NWAccessUserIdAndToken, userService, commonService } from '@ol/ol-ui-core';
import errorHandlerService from '@/services/error/error.handler.service';

class SsoService {
  public async loginContextScriptInit(): Promise<void> {
    const loginContextJs: string = await siteConfigService.getApiEndpoint('auth.ssoTokenRetrieveUrl');
    try {
      const url: string = `${loginContextJs}`;
      const config: HttpRequestConfig = new HttpRequestConfig();
      config.url = url;
      config.dataType = HttpRequestDataType.SCRIPTP;
      const res: HttpResponse<string> = await httpService.get<string>(url, config);
      // @ts-ignore
      await this.initSaveSSOAndCurrentOrg();
      // @ts-ignore
      Logger.info('User is logged in');
    } catch (error) {
      Logger.info('User is not logged in');
      await logoutHandler.logout();
    }
  }

  async initSaveSSOAndCurrentOrg(): Promise<void> {
    const plId: number = await storageService.getPrivateLabelId();
    const hasSSOToken: boolean = await userService.hasSsoToken(plId);

    if (!hasSSOToken) {
      await this.saveSSOTokenFromLoginContext();
    }

    const currentOrgId: number = await userService.getCurrentOrgId(plId);

    if (!currentOrgId) {
      await loginService.saveStdplCurrentSelectedOrg();
    }
  }


  public async saveSSOTokenFromLoginContext():Promise<void> {
    const plId: number = await storageService.getPrivateLabelId();
    // @ts-ignore
    if (typeof com !== 'undefined') {
      const ssoTOken : SSOToken = new SSOToken();
      // @ts-ignore
      ssoTOken.token = com.openlane.auction.ssotoken;
      await commonService.getOrGenerateCommonProperties(plId, null, ssoTOken.token, null, null);
    }
  }

  public async getNWAccessUserIdAndToken(ssoToken: SSOToken): Promise<NWAccessUserIdAndToken> {
    const plId: number = await storageService.getPrivateLabelId();
    const nwAccessUserIdAndToken = await userService.getNWAccessUserIdAndToken(
      plId,
      ssoToken.token,
      false,
    );
    return nwAccessUserIdAndToken;
  }

  public async ssoTokenValidation() {
    const plId: number = await storageService.getPrivateLabelId();
    const isLoggedIn = await loginService.isLoggedIn();
    if (isLoggedIn) {
      const ssoToken: string = await userService.getSsoToken(plId);
      const res = await ssoTokenValidationService.getSSOTokenStatus(plId, ssoToken);
      if (res && res.tokenStatus === 'EXPIRED_TOKEN') {
        await errorHandlerService.handle401Error(null);
      }
    }
  }
}


// Export a singleton instance in the global namespace
export const ssoService = new SsoService();
